import React from 'react';
import { Section } from './Section';
import { useLanguage } from './LanguageContext';
export function TheQuestion() {
  const {
    t
  } = useLanguage();
  return <Section className="bg-barber-red text-white py-24" data-id="element-436">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-437">
        <h2 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-widest mb-12 text-white/90" data-id="element-438">
          {t('question.heading')}
        </h2>
        <div className="space-y-6 text-2xl md:text-3xl font-heading font-light leading-tight" data-id="element-439">
          <p data-id="element-440">{t('question.q1')}</p>
          <p data-id="element-441">{t('question.q2')}</p>
          <p data-id="element-442">{t('question.q3')}</p>
        </div>
        <div className="pt-12 mt-12 border-t border-white/20" data-id="element-443">
          <p className="text-2xl md:text-3xl font-bold mb-2" data-id="element-444">
            {t('question.a1')}
          </p>
          <p className="text-3xl md:text-4xl font-heading font-bold uppercase tracking-widest text-barber-black" data-id="element-445">
            {t('question.a2')}
          </p>
        </div>
      </div>
    </Section>;
}